export const creator_DPUDE2FI = {
    custom_button_label: {
        recurring: 'View plans',
        recurring_single_plan: 'View plans',
    }
};